import React from "react";
import { useState } from "react";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";

const Ifexexpo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const Ifexexpo_image = [
    {
      src: require("../../../src/images/ifexexpo/ifex.1.jpg"),
    },
    {
      src: require("../../../src/images/ifexexpo/ifex.2.jpg"),
    },
    {
      src: require("../../../src/images/ifexexpo/ifex.3.jpg"),
    },
    {
      src: require("../../../src/images/ifexexpo/ifex.4.jpg"),
    },
    {
      src: require("../../../src/images/ifexexpo/ifex.5.jpg"),
    },
    {
      src: require("../../../src/images/ifexexpo/ifex.6.jpg"),
    },
  ];

  return (
    <div>
      <div className="dlab-img-effect on rotate no-hover">
        <div
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <img
            // className="w-100"
            src={require("../../../src/images/ifexexpo/ifex.1.jpg")}
            alt="Image with object-fit: cover"
            style={{
              width: "370px",
              height: "250px",
              objectFit: "cover",
            }}
          />
        </div>
        <div className="dlab-info-has p-a20 no-hover ">
          <div className="dlab-post-title">
            <h5 className="post-title" style={{color: "black", backgroundColor: "white", padding: "5px"}}>IFEX Expo Chennai 2020</h5>
          </div>
        </div>
      </div>
      <SlideshowLightbox
        theme="lightbox"
        images={Ifexexpo_image}
        showThumbnails={true}
        open={isOpen}
        lightboxIdentifier="lbox1"
        onClose={() => {
          setIsOpen(false);
        }}
      ></SlideshowLightbox>
    </div>
  );
};

export default Ifexexpo;
